import { isNewMandantNrFormat, resolveCoachInitialLetter } from './mandantNrFormat';

export const resolveCoachSuffix = (betreuer: string, team?: any[]): string => {
    const letter = resolveCoachInitialLetter(betreuer, team);
    return letter ? `-${letter}` : '';
};

export const resolveDisplayMandantNr = (
    rawMandantNr: string,
    betreuer: string,
    team?: any[]
): string => {
    if (!rawMandantNr) return '---';
    try {
        // Neues Format bereits vollständig in der DB — nicht mit -C verbiegen
        if (isNewMandantNrFormat(rawMandantNr)) {
            return rawMandantNr.trim();
        }
        const cleanNr = rawMandantNr.replace(/(?:[-\s]+[a-zA-Z])+$/, '').trim();
        return `${cleanNr}${resolveCoachSuffix(betreuer, team)}`;
    } catch {
        return String(rawMandantNr);
    }
};

const nameFromSource = (src: any): string => {
    if (!src) return '';

    const vorname = src.vorname || src.firstName || '';
    const nachname = src.nachname || src.lastName || '';
    if (vorname && nachname) return `${vorname} ${nachname}`.trim();

    if (src.unternehmername) return String(src.unternehmername).trim();

    const combined = `${vorname} ${nachname}`.trim();
    if (combined) return combined;

    if (src.firmenname) return String(src.firmenname).trim();
    if (src.salonname) return String(src.salonname).trim();

    return '';
};

export const resolveClientFullName = (opts: {
    godModeClient?: any;
    userData?: any;
    clientData?: any;
}): string => {
    const sources = [
        opts.godModeClient,
        opts.godModeClient?.clientData,
        opts.userData,
        opts.userData?.clientData,
        opts.clientData,
    ];

    for (const src of sources) {
        const name = nameFromSource(src);
        if (name) return name;
    }

    return 'Mandant';
};
